/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiNumeroUtileDeleteNumeroUtileByIdDelete$Params {
    /**
     * Id del numero utile da eliminare
     */
    numeroUtileId: number;
}

export function apiNumeroUtileDeleteNumeroUtileByIdDelete(
    http: HttpClient,
    rootUrl: string,
    params: ApiNumeroUtileDeleteNumeroUtileByIdDelete$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiNumeroUtileDeleteNumeroUtileByIdDelete.PATH, 'delete');
    if (params) {
        rb.query('numeroUtileId', params.numeroUtileId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiNumeroUtileDeleteNumeroUtileByIdDelete.PATH = '/api/numero-utile/delete-numero-utile-by-id';
